

































import { Prop, Component, Mixins } from 'vue-property-decorator'
import { Order } from '@/api/model/order'
import DetailHeader from '@/views/Tasks/Detail/ReferralDetails/ReferralDetailHeader.vue'
import DeleteOrderModal from '@/components/modal/DeleteOrderModal.vue'

@Component({
    components: {
        DeleteOrderModal,
    },
})
export default class OrderDetailHeader extends Mixins(DetailHeader) {
    @Prop({ required: true }) readonly order!: Order
    deleteOrderModalVisible: boolean = false

    generateOrderStatusClasses(status: string) {
        const classes = {
            pending: 'pending',
            successful: 'closed',
            unsuccessful: 'closed',
        }

        return classes[status]
    }
}
